import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

const Auth0Callback = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user, isLoading, error, getAccessTokenSilently } = useAuth0();
  
  useEffect(() => {
    if (error) {
      console.error('Auth0 error:', error);
      navigate('/login?error=auth_failed');
      return;
    }
    
    if (!isLoading && isAuthenticated && user) {
      console.log('Auth0 user authenticated:', user);
      
      // Send JWT to backend for validation and role assignment
      validateWithBackend();
    }
  }, [isAuthenticated, user, isLoading, error, navigate]);
  
  const validateWithBackend = async () => {
    try {
      // Get Auth0 access token
      const token = await getAccessTokenSilently();
      console.log('Got Auth0 token, validating with backend...');
      
      // Send token to backend for validation
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/validate-auth0`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: user.email,
          auth0_token: token
        })
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log('Backend validation successful:', data);
        
        // Redirect based on backend response
        navigate(data.redirect_url);
      } else {
        const errorData = await response.json();
        console.error('Backend validation failed:', errorData);
        navigate('/login?error=backend_validation_failed');
      }
      
    } catch (error) {
      console.error('Failed to validate with backend:', error);
      navigate('/login?error=validation_error');
    }
  };
  
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4" style={{
        background: 'linear-gradient(135deg, #207CE5 0%, #008B8B 100%)'
      }}>
        <div className="glass-effect rounded-2xl p-8 shadow-xl text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
          <p className="text-white text-lg">Authenticating...</p>
          <p className="text-white text-sm mt-2">Setting up your session...</p>
        </div>
      </div>
    );
  }
  
  return null;
};

export default Auth0Callback;